


















import Vue from "vue";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";
import router from "@/router";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "Logout",
  components: { VelloIcon },
  computed: {
    ...mapGetters(["GET_LOADING_STATUS", "GET_CSRF_INFORMATION"])
  },
  methods: {
    ...mapActions(["USER_LOGOUT"])
  },
  created() {
    this.$store
      .dispatch("USER_LOGOUT", this.GET_CSRF_INFORMATION.token)
      .then(() => {
        setTimeout(() => {
          window.location.replace(
            `${process.env.VUE_APP_VELLO_URL}/${router.currentRoute.params.locale}`
          );
        }, 500);
      })
      .catch(error => {
        console.error(`[Logout view]: Failed logout: ${error.message}`);
      });
  }
});
